import Vue from 'vue'

export const customerTypes = async function() {
  return [{header:'SK'},
                              {text:'Licensee',value:'Licensee',spirit:false,wine:false,prefInBond:false},
                              {text:'Contract',value:'Contract',spirit:false,wine:false,prefInBond:true},
                              {text:'SLGA Distribution',value:'SLGADistribution',spirit:false,wine:false,prefInBond:false}];
}
